import {
  getTextStyle,
  handleLabelFormatting,
  handleTooltipFormatting,
} from "../../utils";

export const line = (
  props: { axis?: { rotate?: boolean }; [key: string]: unknown } = {},
  data: { [key: string]: { [key: string]: any } | string[] } = {},
) => {
  const legendTextStyle = getTextStyle(props, "legend");
  const axisTextStyle = getTextStyle(props, "axis");
  const annotationTextStyle = getTextStyle(props, "annotation");
  const isMobile: boolean = window.innerWidth <= 768;
  const isLegend = props.showLegend && (data.series as unknown[]).length > 1;
  const overValidationChar: boolean = data.titles.some(
    (title: string) => title.length > 5,
  );
  let gridOptions: { [key: string]: number } = {};
  const isAreaChartType = [
    "horizontal-area",
    "horizontal-smooth-area",
  ].includes(props.chartType as string);
  let legendOptions: Record<string, unknown> = {
    show: isLegend,
    type: "scroll",
    itemGap: 16,
    itemStyle:
      data.series.length === 1
        ? { color: "transparent", borderColor: props.color, borderWidth: 1 }
        : {},
    textStyle: {
      ...legendTextStyle,
    },
  };

  if (isLegend) {
    switch (props.legendPosition) {
      case "bottom":
        legendOptions = { ...legendOptions, bottom: 0 };
        gridOptions = {
          top: 48,
          bottom: 48,
          left: 10,
          right: isAreaChartType ? 25 : 10,
        };
        break;
      case "top":
        legendOptions = { ...legendOptions, top: 0 };
        gridOptions = {
          bottom: 3,
          top: 48,
          left: 10,
          right: isAreaChartType ? 25 : 10,
        };
        break;
    }
  } else {
    gridOptions = {
      top: 25,
      bottom: 3,
      left: 10,
      right: isAreaChartType ? 25 : 10,
    };
  }

  return {
    xAxis: {
      type: "category",
      z: 10,
      data: data.titles || [],
      boundaryGap: !isAreaChartType,
      axisLabel: {
        hideOverlap: true,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        interval: 0,
        ...axisTextStyle,
        rotate: (props.axis?.rotate ?? overValidationChar) ? 45 : 0,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    tooltip: {
      formatter: (params: Record<string, string | number>) =>
        handleTooltipFormatting(params, props.prefix, props.suffix),
    },
    yAxis: {
      type: "value",
      boundaryGap: [0, 0],
      splitLine: {
        show: props.showGridlines,
        lineStyle: {
          color: props.darkMode ? "rgba(255, 255, 255, 0.15)" : "#E0E6F1",
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: `${props.prefix ? props.prefix : ""}{value}${props.suffix ? props.suffix : ""}`,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        ...axisTextStyle,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    title: {
      show: false,
    },
    textStyle: {
      color: props.color,
      fontFamily: props.fontFamily,
    },
    animation: props.animation,
    series: data.series || [],
    legend: legendOptions,
    labelLayout: { hideOverlap: true },
    label: {
      show: props.showAnnotation,
      formatter: (params: Record<string, string | number>) =>
        handleLabelFormatting(params, props.prefix, props.suffix),

      ...annotationTextStyle,
    },
    grid: { ...gridOptions, containLabel: true },
  };
};
